<main class="main vh-100">
  <section class="auth-login h-100">
    <div class="container-fluid h-100 px-0">
      <div class="row h-100 mx-0">
        <div class="col-md-6 pl-md-0 d-none d-md-block">
          <div class="auth-login-car h-100">
            <div class="auth-login-carAnimation">
              <img
                src="{{ env }}assets/img/car.png"
                class="auth-login-carImg"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="col-md-6 px-0 pl-md-3 pr-md-0">
          <div class="auth-form-module">
            <form
              method="POST"
              class="auth-login-form credential"
              [formGroup]="loginForm"
              (submit)="login()"
            >
              <div class="auth-login-formHeader text-right mb-5">
                <a href="" class="auction-logo ml-auto">
                  <img
                    src="{{ env }}assets/img/auction_logo2.svg"
                    alt="Altawkilat-Auction"
                    class="auction-logo-img"
                  />
                </a>
              </div>

              <div class="form-group">
                <input
                  id="email"
                  type="email"
                  class="form-control credential__input transparent"
                  name="email"
                  formControlName="email"
                  placeholder="Email"
                  [class.is-invalid]="formData.email.invalid && submitted"
                />

                <div class="errors" *ngIf="formData.email.invalid && submitted">
                  <ng-container *ngIf="formData.email.errors?.required"
                    >Email is required.</ng-container
                  >
                  <ng-container *ngIf="formData.email.errors?.email"
                    >Please enter a valid email.</ng-container
                  >
                </div>
              </div>

              <div class="form-group">
                <input
                  id="password"
                  type="password"
                  class="form-control credential__input transparent"
                  name="password"
                  formControlName="password"
                  placeholder="Password"
                  [class.is-invalid]="formData.password.invalid && submitted"
                />

                <div
                  class="errors"
                  *ngIf="formData.password.invalid && submitted"
                >
                  <ng-container *ngIf="formData.password.errors?.required"
                    >Password is required.</ng-container
                  >
                  <ng-container *ngIf="formData.password.errors?.minlength">
                    Required
                    {{
                      formData.password.errors?.minlength.requiredLength -
                        formData.password.errors?.minlength.actualLength
                    }}
                    more characters/digits.
                  </ng-container>
                </div>
              </div>

              <div class="auth-form-btnGrp mb-4">
                <button
                  type="submit"
                  [ladda]="loader.loading | async"
                  data-style="slide-left"
                  class="btn btn__main fs-normal w-100"
                >
                  Login
                </button>
              </div>

              <div class="form-group mb-4">
                <div class="row mx-0">
                  <div class="col-6 pl-0">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input color-yellow"
                        type="checkbox"
                        name="remember"
                        id="remember"
                      />

                      <label
                        class="
                          form-check-label
                          custom-control-label
                          credential__label
                        "
                        for="remember"
                      >
                        Remember Me
                      </label>
                    </div>
                  </div>

                  <div class="col-6 pr-0">
                    <a
                      class="color-navy text-decoration-none"
                      routerLink="/forgot-password"
                    >
                      Forgot Password?
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <app-loader *ngIf="loader.loading | async"></app-loader> -->
</main>
